import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CandleContext = createContext(null);

export function CandleProvider({ children }) {
  const [count, setCount] = useState(null);
  const [lit, setLit] = useState(false);
  const [flame, setFlame] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/candles`).then((r) => setCount(r.data.count)).catch(() => {});
    // La bougie démarre éteinte à chaque visite : c'est le visiteur qui l'allume.
    setLit(localStorage.getItem("memorium-candle") === "1");
  }, []);

  const light = useCallback(async () => {
    if (lit) {
      setFlame(true);
      toast.success("Votre bougie se rallume en sa mémoire.");
      return;
    }
    if (busy) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API}/candles`);
      setCount(r.data.count);
      setLit(true);
      setFlame(true);
      localStorage.setItem("memorium-candle", "1");
      toast.success("Une bougie s'allume en sa mémoire.");
    } catch {
      toast.error("Impossible d'allumer la bougie pour le moment.");
    } finally {
      setBusy(false);
    }
  }, [lit, busy]);

  const toggle = useCallback(async () => {
    if (!lit) {
      await light();
      return;
    }
    setFlame((f) => {
      if (!f) toast.success("Votre bougie se rallume en sa mémoire.");
      return !f;
    });
  }, [lit, light]);

  return (
    <CandleContext.Provider value={{ count, lit, flame, busy, light, toggle }}>
      {children}
    </CandleContext.Provider>
  );
}

export const useCandle = () => useContext(CandleContext);
